class Form {
    constructor(data) {
        Object.assign(this, data);
    }
}

export default Form;